import {Component, Input, OnInit} from '@angular/core';
import {
  BokkzAlgDataService,
  BokkzBtwDataService,
  BokkzBtwLogic,
  BtwOverzicht,
  FiscaleEenheidBtw,
  KolommenbalansService,
  ValueAddedTaxEntity,
} from "@snelstart-ventures/fiscaal/domain-logic";
import {FormArray, FormBuilder, FormGroup} from "@angular/forms";
import { SelectFormControlItem, SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { SharedUiButtonModule } from '@snelstart/ui-button';
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-fiscale-eenheid-vat',
  templateUrl: './fiscale-eenheid-vat.component.html',
  styleUrls: ['./fiscale-eenheid-vat.component.scss'],
  imports: [
    SharedUiButtonModule,
    SharedUiFormControlsModule,
    SharedUiDetailsModule,
    CommonModule
  ]
})
export class FiscaleEenheidVatComponent implements OnInit {

  @Input() public id!: string;
  public vatEntity = <ValueAddedTaxEntity>{};
  public fiscaleEenheidFg = <FormGroup>{};
  public options: SelectFormControlItem<string>[] = [];
  public focusedElementId: string | null = null;
  public formStructure: any;
  public dialogVisible = false;

  public optionsJaNee: SelectFormControlItem<boolean>[] = [
    {value: false, label: "Moeder"},
    {value: true, label: "Dochter"},
  ];

  constructor(
    public bokkzDataService: BokkzAlgDataService,
    public dataService: BokkzBtwDataService,
    public vpbService: BokkzBtwLogic,
    private kolommenbalansService: KolommenbalansService,
    private fb: FormBuilder) {
    this.fiscaleEenheidFg = this.fb.group({
      samenstelling: this.fb.array([])
    })
  }

  showDialog() {
    this.dialogVisible = true;
  }

  get samenstelling(): FormArray {
    return this.fiscaleEenheidFg.get('samenstelling') as FormArray;
  }

  addRij(): void {
    this.samenstelling.push(this.createFormGroup(), { emitEvent: false })
  }

  verwijderRij(index: number): void {
    this.samenstelling.removeAt(index, { emitEvent: false });
    this.saveForm();
  }

  createFormGroup(item?: FiscaleEenheidBtw): FormGroup {
    return this.fb.group({
      naamOnderneming: item ? item.naamOnderneming : null as unknown as string,
      datumOpname: item ? item.datumOpname : null as unknown as string,
      datumEinde: item ? item.datumEinde: null as unknown as string,
      omzetbelastingNummer: item ? item.omzetbelastingNummer : null as unknown as string,
      sstAdminId: item ? item.sstAdminId : null as unknown as string,
    });
  }

  trackByFn(index: number): any {
    return index;
  }

  ngOnInit(): void {
    this.dataService.valueAddedTaxEntity.subscribe((value) => {
      this.vatEntity = value;
      this.updateForm();
    })
    this.bokkzDataService.options.subscribe((value) => {
      this.options = value;
    });
  }

  private updateForm(): void {
    const lijst = this.vatEntity?.overzicht?.fiscaleEenheidBtwList || [];
    const formArray = this.fiscaleEenheidFg.get('samenstelling') as FormArray;
    const focusedControl = this.focusedElementId ? document.getElementById(this.focusedElementId) as HTMLElement : null;

    while (formArray.length > lijst.length) {
      formArray.removeAt(formArray.length - 1, {emitEvent: false});
    }

    for (let i = 0; i < lijst.length; i++) {
      if (i < formArray.length) {
        const control = formArray.at(i) as FormGroup;
        control.patchValue(lijst[i], {emitEvent: false});
      } else {
        const formGroup = this.createFormGroup(lijst[i])
        formArray.push(formGroup, {emitEvent: false});
      }
    }

    if (focusedControl && document.contains(focusedControl)) {
      focusedControl.focus();
    }
  }

  saveForm(): void {
    this.vatEntity.overzicht = {
      ...this.vatEntity.overzicht,
      fiscaleEenheidList: this.fiscaleEenheidFg.getRawValue().samenstelling,
    } as BtwOverzicht;
    this.dataService.updateValueAddedTaxEntity(this.vatEntity);
  }
}
